import React, { Component } from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from 'react-bootstrap';
import { Link } from "gatsby";
import edge_setup from '../images/edge_how_2_use.png';
import favicon from '../images/favicon.ico'

import Layout from '../Frame/Layout';
import { Helmet } from "react-helmet";
import { window, document } from 'browser-monads'

class HowToUse extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <Layout>
                <Helmet>
                    <title>How to Use - Edge.Poker</title>
                    <meta name="description" content="A simple how-to-use page to help you get started with Edge.Poker, the free online poker odds & analyzer." />
                    <link rel="canonical" href="https://app.edge.poker/how-to-use" />
                    <link rel="icon" href={favicon} />
                    <meta http-equiv="content-language" content="en-us"></meta>
                    <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Roboto&display=swap" onload="this.onload=null;this.rel='stylesheet'"></link>  
                    <script src="/sl.js" type='text/javascript'/>
                </Helmet>
                <Row>
                    <Col xs="12" className="mb-4 mt-4 text-center">
                        <h1 className="title">How to Use Edge.Poker</h1>
                    </Col>

                    <Col xs="12">
                        <p>
                            We believe the best way to use <Link to="/">our odds calculator</Link> is to use it real-time in 
                            online poker game. We advise our users to set up Edge.Poker as shown in the figure below:
                        </p>
                        <div className="text-center mt-5 mb-5">
                            <img src={edge_setup} className="how-to-use-img" alt="How to Setup Edge to Play Online Poker" />
                        </div>
                        <p>
                            Once you have the above setup, we suggest the following way to use Edge.Poker
                            as you play the game:
                        </p>
                        <ol>
                            <li>
                                When you receive a hand that you want to play, enter your hands
                                into Edge.Poker. Edge.Poker should automatically calculate the result when all needed info is entered. 
                                Do not click on anything in the game yet.
                                There will be enough time to make a decision.
                            </li>
                            <li>
                                Read "My Win Rate" and "Action". Consider if opponents' bet size is too agressive.
                                Only then, should you decide to call, fold or raise in the game. We recommend
                                not to use the early action checkbox available in the game. This will give away too
                                much cues to your opponents. 
                            </li>
                            <li>
                                If you decide to continue, always start again from point #1 once you received
                                the flop, turn and river.
                            </li>
                            <li>
                                Once you are ready for a new round, click on "Clear Cards".
                            </li>
                        </ol>
                        <p>
                            Note: We advise heavily against entering hand plus flop in one go.
                            This will cause unnecessary stress since entering many inputs 
                            in a few seconds can be quite difficult.
                        </p>
                        <p>
                            Edge.Poker is best used for cash game. The success rate of using Edge.Poker
                            with tournament is more luck dependant. Tournaments are designed to weed out
                            low chip players quickly. Therefore, it is important to make sure your
                            chip stack is sufficient to allow you to bet decent amount of big blinds.
                            The more chips you have early on, the better Edge.Poker will work in a tournament setting.
                        </p>
                        <p>
                            If you want to learn more about how Edge.Poker works, visit our <Link to="/about">About</Link> page.
                        </p>
                        <p>
                            Have fun with Edge.Poker!
                        </p>
                    </Col>
                </Row>
            </Layout>
        )
    }
}

export default HowToUse;